<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">用户管理</p>
		</sub-ibox-title>
		<z-tab-bar :list-obj="tabBarParams.list" :active="tabBarParams.active" @handleClickTabBar="handleClickTabBar"></z-tab-bar>
		<section>
			<div class="member-cont">
				<h3 class="fx">
					<p class="p-r-10">今日指标</p>
					<div class="question-cont">
						<i class="icon-question "></i>
						<div class="question-explain">
							<h5>新关注人数</h5>
							<p>新关注的去重用户数</p>
							<h5>取消关注人数</h5>
							<p>取消关注的去重用户数</p>
							<h5>净增关注人数</h5>
							<p>净增长的去重关注用户数</p>
							<h5>累积关注人数</h5>
							<p>当前关注的用户总数</p>
						</div>
					</div>
				</h3>
				<div class="member-data">
					<ul class="fx text-center">
						<li>
							<strong>{{fansCount.todayCount}}</strong>
							<p>新关注人数</p>
						</li>
						<li>
							<strong>{{fansCount.todayCancelCount}}</strong>
							<p>取消关注人数</p>
						</li>
						<li>
							<strong>{{fansCount.todayCount-fansCount.todayCancelCount}}</strong>
							<p>净增关注人数</p>
						</li>
						<li>
							<strong>{{fansCount.count}}</strong>
							<p>累积关注人数</p>
						</li>
					</ul>
				</div>
			</div>
			<div class="member-key-cont">
				<h3 class="fx">
					<div class="p-r-10">最近7天粉丝指标（不包括今天）
						<!--<span>|</span>
						<span class="p-l-10">最近7天用户数据</span>-->
					</div>
					<!--<div class="question-cont">
						<i class="icon-question"></i>
						<div class="question-explain">
							<h5>累计粉丝数</h5>
							<p>关注的粉丝总数</p>
							<h5>净增粉丝数</h5>
							<p>净增粉丝数为新增粉丝总数减去取消关注的粉丝总数</p>
							<h5>新增粉丝数</h5>
							<p>新增的粉丝总数</p>
							<h5>取消关注粉丝数</h5>
							<p>取消关注的粉丝总数</p>
						</div>
					</div>-->
				</h3>
				<div class="member-data">
					<div id="memberChart" style="width:auto;height: 400px;"></div>
				</div>
			</div>
			<div class="member-key-cont fx fx-x-between">
				<div class="chart-cont">
					<h3 class="fx">
						<div class="p-r-10">粉丝来源</div>
						<div class="question-cont">
							<i class="icon-question"></i>
							<div class="question-explain">
								<h5>粉丝来源分析(不包括今天)</h5>
								<p>近7天粉丝从各种渠道关注公众号分析</p>
							</div>
						</div>
					</h3>
					<div class="source-data">
						<div id="sourceChart1"></div>
					</div>
				</div>
				<div class="chart-cont">
					<h3 class="fx">
						<div class="p-r-10">粉丝性别</div>
						<div class="question-cont">
							<i class="icon-question"></i>
							<div class="question-explain">
								<h5>粉丝性别</h5>
								<p>粉丝性别分析</p>
							</div>
						</div>
					</h3>
					<div class="source-data">
						<div id="sourceChart2"></div>
					</div>
				</div>
				<div class="chart-cont">
					<h3 class="fx">
						<div class="p-r-10">粉丝地域</div>
						<div class="question-cont">
							<i class="icon-question"></i>
							<div class="question-explain">
								<h5>粉丝地域</h5>
								<p>粉丝主要来自的地区分析</p>
							</div>
						</div>
					</h3>
					<div class="source-data">
						<div id="sourceChart3"></div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	let memberChart = null,
		sourceChart1 = null,
		sourceChart2 = null,
		sourceChart3 = null;
	export default {
		name: 'WxMember',
		data() {
			return {
				tabBarParams: {
					list: [{
						title: '粉丝分析',
						type: 'fansCount'
					}, {
						title: '粉丝列表',
						type: 'fansList'
					}],
					active: 'fansCount' //默认
				},
				memberOption: {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['累计粉丝数', '净增粉丝数', '新增粉丝数', '取消关注粉丝数']
					},
					grid: {
						left: '3%',
						right: '4%',
						//				        bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: []
					},
					yAxis: {
						type: 'value'
					},
					series: [{
							name: '累计粉丝数',
							type: 'line',
							stack: '数量4',
							data: []
						}, {
							name: '净增粉丝数',
							type: 'line',
							stack: '数量1',
							data: []
						},
						{
							name: '新增粉丝数',
							type: 'line',
							stack: '数量2',
							data: []
						},
						{
							name: '取消关注粉丝数',
							type: 'line',
							stack: '数量3',
							data: []
						}
					]
				},
				sourceOption1: {
					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b}: {c} ({d}%)"
					},
					legend: {
						orient: 'vertical',
						x: 'let',
						data: []
					},
					grid: {
						left: '50%',
						top:'20%',
						right:'20%',
						bottom:'20%',
						containLabel: true
					},
					series: [{
						name: '粉丝来源',
						type: 'pie',
						center: ['60%', '45%'],
						radius: ['50%', '70%'],
						avoidLabelOverlap: false,
						label: {
							normal: {
								show: false,
								position: 'center'
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '16',
									fontWeight: 'bold'
								}
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: [{}]
					}]
				},
				sourceOption2: {
					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b} : {c} ({d}%)"
					},
					series: [{
						name: '粉丝性别',
						type: 'pie',
						radius: '70%',
						center: ['50%', '45%'],
						data: [],
						label: {
							normal: {
								textStyle: {
									color: 'rgba(147, 157, 161, 1)'
								}
							}
						},
					}]
				},
				sourceOption3: {
					title: {
						text: '',
						subtext: '粉丝主要来源...'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',
						data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
					},
					series: [

						{
							name: '数量',
							type: 'bar',
							data: [100, 200, 200, 500, 11, 52]
						}
					]
				}
			}
		},
		mounted() {
			this.getFansCount()
			this.getFansAnalysis()
			this.initEcharts()
			window.onresize = function() {
				memberChart.resize();
				sourceChart1.resize();
				sourceChart2.resize();
				sourceChart3.resize();
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				fansAnalysis: state => state.fans.fansAnalysis,
				fansCount: state => state.fans.fansCount
			})
		},
		watch: {
			fansAnalysis: 'setChartData',
			fansCount:'setFansCount'
		},
		/*
		 * 事件处理
		 */
		methods: {
			initEcharts() {
				//初始化图表
				memberChart = this.$echartsInit('memberChart', {
					width: 'auto',
					height: 400
				})

				sourceChart1 = this.$echartsInit('sourceChart1', {
					width: 'auto',
					height: 300
				})
				sourceChart2 = this.$echartsInit('sourceChart2', {
					width: 'auto',
					height: 300
				})
				sourceChart3 = this.$echartsInit('sourceChart3', {
					width: 'auto',
					height: 300
				})
				memberChart.setOption(this.memberOption);
				sourceChart1.setOption(this.sourceOption1);
				sourceChart2.setOption(this.sourceOption2);
				sourceChart3.setOption(this.sourceOption3);
			},
			setChartData() {
				let xAxisData = [],
					cumulateUser = [],
					addUser = [],
					newUser = [],
					cancelUser = []
				let {
					cumulateList,
					sourceList
				} = this.fansAnalysis
				cumulateList.map((item, index) => {
					xAxisData.push(item.ref_date)
					cumulateUser.push(item.cumulate_user)
					newUser.push(item.new_user)
					cancelUser.push(item.cancel_user)
					addUser.push(item.add_user)
				})
				let sourceTitle = [],
					sourceValue = []
				sourceList.map((item, index) => {
					sourceTitle.push(item.name)
					sourceValue.push(item.value)
				})

				memberChart.setOption({
					xAxis: {
						data: xAxisData
					},
					series: [{
							name: '累计粉丝数',
							data: cumulateUser
						},
						{
							name: '净增粉丝数',
							data: addUser
						},
						{
							name: '新增粉丝数',
							data: newUser
						},
						{
							name: '取消关注粉丝数',
							data: cancelUser
						}
					]
				});

				sourceChart1.setOption({
					legend: {
						data: sourceTitle
					},
					series: {
						data: sourceList
					}
				})
				
				memberChart.resize();
				sourceChart1.resize();
			},
			setFansCount(){
				sourceChart2.setOption({
					series: {
						data:[{
							name:'男',
							value:this.fansCount.man
						},{
							name:'女',
							value:this.fansCount.girl
						},{
							name:'未知',
							value:this.fansCount.nosex
						}]
					}
				})
				sourceChart2.resize();
				const title = Object.assign([],this.fansCount.area.areaName)
			    sourceChart3.setOption({
			    			title:{
			    				subtext:'粉丝主要来自:'+(title.reverse()).join(',')
			    			},
					    	yAxis: {
					        	data: this.fansCount.area.areaName
					    	},
						    series: [
						        {
						            data: this.fansCount.area.areaValue
						        }
						    ]
			    })
				sourceChart3.resize();
			},
			handleClickTabBar(type) { //切换tabbar
				if(type == "fansList") {
					this.$router.replace({
						name: 'wxMemberList'
					})
				} else {
					this.$router.replace({
						name: 'wxMember'
					})
				}
			},
			...mapActions(['getFansCount', 'getFansAnalysis'])
		}
	}
</script>

<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.member-cont,
	.member-key-cont {
		background: $color-white;
		border: 1px solid $color-border;
		h3 {
			height: px-em(88px);
			line-height: px-em(88px);
			padding: 0 px-em(40px);
		}
		.member-data {
			color: $color-font-sub;
			padding: px-em(80px) 0;
			strong {
				display: block;
				padding: px-em(20px) 0;
				font-size: px-em(36px);
				color: $color-main;
			}
		}
	}
	
	.member-cont {
		li {
			width: 50%;
		}
	}
	
	.source-data {
		padding: 0 px-em(40px);
	}
	
	.member-key-cont {
		border-top: none;
		li {
			width: 25%;
		}
		.chart-cont {
			width: 32%;
			/*background: lightcoral;*/
		}
	}
	
	.question-cont {
		.icon-question {
			color: $color-warning;
		}
		position: relative;
		&:hover .question-explain {
			visibility: visible;
			opacity: 1;
		}
		.question-explain {
			z-index: 999999;
			transition: all 0.2s ease;
			visibility: hidden;
			opacity: 0;
			border: 1px solid $color-border;
			background: $color-white;
			padding: px-em(40px);
			position: absolute;
			left: 30px;
			top: 10px;
			line-height: 2;
			width: 300px;
			p {
				color: $color-font-sub;
				padding-bottom: 10px;
				font-size: 12px;
			}
		}
	}
	
	@media only screen and (min-width:0px) and (max-width:640px) {
		.icon-question {
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// WxMember.vue?3bb1d898